import React from "react";
import { CheckCircle, Circle } from "@phosphor-icons/react";

const NEW_STEPS = [
  ["company", "Company & contact", "Start here"], ["criteria", "Lead criteria"], ["pages", "Landing pages"],
  ["delivery", "Delivery & test"], ["live", "Go live"],
].map(([key, label, note]) => ({ key, label, done: false, note: note || "Save the company first" }));

export function SetupSteps({ steps, current, onPick }) {
  const rows = steps || NEW_STEPS;
  return (
    <ol className="flex md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-1 md:pb-0" data-testid="setup-steps">
      {rows.map((s, i) => {
        const on = s.key === current;
        const locked = !steps && s.key !== "company";
        return (
          <li key={s.key} className="shrink-0 md:shrink">
            <button type="button" disabled={locked} onClick={() => onPick(s.key)} data-testid={`setup-step-nav-${s.key}`}
                    aria-current={on ? "step" : undefined}
                    className={`w-44 md:w-full text-left border-2 border-black px-3 py-2 flex gap-2 transition-colors duration-150 disabled:opacity-40 ${on ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
              {s.done
                ? <CheckCircle size={18} weight="fill" className={on ? "text-emerald-300" : "text-emerald-600"} />
                : <Circle size={18} weight="bold" />}
              <span className="min-w-0">
                <span className="block text-[11px] uppercase tracking-widest font-bold">{i + 1}. {s.label}</span>
                <span className={`block text-[11px] leading-snug ${on ? "text-zinc-300" : "text-zinc-500"}`} data-testid={`setup-step-note-${s.key}`}>
                  {s.done ? "Done" : s.note}
                </span>
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
